import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotTollRatesApiMeta } from "../apiMeta";
import {
  type TripRatesByVersionInput,
  tripRatesByVersionInputSchema,
} from "./shared/tollTripRates.input";
import {
  type TollTripsRates,
  tollTripsRatesSchema,
} from "./shared/tollTripRates.output";

/**
 * Metadata for the fetchTripRatesByVersion endpoint
 */
export const tripRatesByVersionMeta = {
  functionName: "fetchTripRatesByVersion",
  endpoint: "/getTripRatesByVersionAsJson?Version={Version}",
  inputSchema: tripRatesByVersionInputSchema,
  outputSchema: tollTripsRatesSchema,
  sampleParams: { Version: 352417 },
  endpointDescription: "Get toll rates for a specific version number.",
} satisfies EndpointMeta<TripRatesByVersionInput, TollTripsRates>;

/**
 * Fetch function for retrieving toll rates for a specific version number
 */
const { fetch, useHook } = createFetchAndHook<
  TripRatesByVersionInput,
  TollTripsRates
>({
  api: wsdotTollRatesApiMeta,
  endpoint: tripRatesByVersionMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/tollTripRates.endpoints").tollTripRatesGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving toll rates for a specific version number
 */
export const fetchTripRatesByVersion: FetchFactory<
  TripRatesByVersionInput,
  TollTripsRates
> = fetch;

/**
 * React Query hook for retrieving toll rates for a specific version number
 */
export const useTripRatesByVersion: HookFactory<
  TripRatesByVersionInput,
  TollTripsRates
> = useHook;
